import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import { ReactElement } from 'react';
import { SsoDisabledActionTooltip } from '../../ory/components/SsoDisabledActionTooltip';
import DataGridActionButton from '../DataGridActionButton';
import DataGridSearchField from '../DataGridSearchField';

interface TableControlPanelProps {
  addButtonAction: () => void;
  addButtonDataTestId?: string;
  addButtonLabel: ReactElement | string;
  createButtonAction?: (() => void) | null;
  createButtonDataTestId?: string;
  createButtonLabel?: ReactElement | string;
  createVisitorButtonAction?: (() => void) | null;
  createVisitorButtonDataTestId?: string;
  createVisitorButtonLabel?: ReactElement | string;
  isGuestAccessFFEnabled?: boolean;
  isUserLoggedAsOrySso?: boolean;
  onSearchFieldChange?: ({ target }: { target: { name: string; value: string } }) => void;
  searchField?: boolean;
  searchFieldDataTestId?: string;
  searchFieldPlaceholder?: ReactElement | string;
  searchFieldText?: string;
  tabToolbar?: boolean;
}

export function TableControlPanel({
  addButtonAction,
  addButtonDataTestId,
  addButtonLabel,
  createButtonAction = null,
  createButtonDataTestId,
  createButtonLabel = '',
  createVisitorButtonAction = null,
  createVisitorButtonDataTestId,
  createVisitorButtonLabel = '',
  isGuestAccessFFEnabled = false,
  isUserLoggedAsOrySso,
  onSearchFieldChange,
  searchField = false,
  searchFieldDataTestId,
  searchFieldPlaceholder = '',
  searchFieldText = '',
  tabToolbar = false,
}: TableControlPanelProps) {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        pb: 1,
        ...(tabToolbar && { px: 3 }),
      }}
    >
      {searchField && (
        <Grid>
          <DataGridSearchField
            dataTestId={searchFieldDataTestId}
            fulltext={searchFieldText}
            onChangeFilter={onSearchFieldChange}
            placeholder={searchFieldPlaceholder}
            size="small"
          />
        </Grid>
      )}
      {createVisitorButtonAction && isGuestAccessFFEnabled && (
        <Grid>
          <SsoDisabledActionTooltip isUserLoggedAsOrySso={isUserLoggedAsOrySso}>
            <DataGridActionButton
              data-testid={createVisitorButtonDataTestId}
              onClick={createVisitorButtonAction}
              startIcon={<AddIcon />}
              sx={{ minHeight: '100%' }}
              variant="outlined"
              disabled={isUserLoggedAsOrySso}
            >
              {createVisitorButtonLabel}
            </DataGridActionButton>
          </SsoDisabledActionTooltip>
        </Grid>
      )}
      {createButtonAction && (
        <Grid>
          <SsoDisabledActionTooltip isUserLoggedAsOrySso={isUserLoggedAsOrySso}>
            <DataGridActionButton
              data-testid={createButtonDataTestId}
              onClick={createButtonAction}
              startIcon={<AddIcon />}
              sx={{ minHeight: '100%' }}
              variant="outlined"
              disabled={isUserLoggedAsOrySso}
            >
              {createButtonLabel}
            </DataGridActionButton>
          </SsoDisabledActionTooltip>
        </Grid>
      )}
      <Grid>
        <DataGridActionButton
          data-testid={addButtonDataTestId}
          onClick={addButtonAction}
          startIcon={<AddIcon />}
          sx={{ minHeight: '100%' }}
          variant={createButtonAction ? 'contained' : 'outlined'}
        >
          {addButtonLabel}
        </DataGridActionButton>
      </Grid>
    </Grid>
  );
}
